import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import _isEmpty from 'lodash/isEmpty';

import ComponentErrorBoundary from 'components/ComponentErrorBoundary';
import { DateControls } from 'components/DateControls';
import Message from 'components/Message';
import { ColumnLayout, Column, Title, Controls, Control } from 'features/App';

import VenueSchedulesContext from './Contexts/VenueSchedulesContext';
import EmptyDetail from './EmptyDetail';
import ScheduleDetail from './ScheduleDetailContainer';
import { ScheduleList } from './ScheduleList';
import { VenueSmartSpotStatus } from './SmartSpot';
import ScheduleListFilterContainer from './ScheduleListFilterContainer';

const messages = defineMessages({
  title: {
    id: 'yield-management.header.title',
    defaultMessage: 'Classes',
  },
});

const YieldManagement = ({ venueId, startDateFormatted, updateStartDate }) => {
  const { activeSchedule: selectedSchedule } = useContext(VenueSchedulesContext);
  const [scrollPos, setScrollPos] = useState(0);

  const listOnFocusEnter = () => {
    if (scrollPos >= 0) {
      window.scrollTo(0, scrollPos);
    }
  };
  const listOnFocusLeave = () => {
    setScrollPos(window.scrollY);
  };

  return (
    <ColumnLayout>
      <Column
        className="column-layout__column--lg-5/12 yield-management__list-column"
        name="list"
        type="flush"
        onFocusEnter={listOnFocusEnter}
        onFocusLeave={listOnFocusLeave}>
        <Message message={messages.title} as={Title} />
        <Controls>
          <Control type="filter">
            <DateControls setDate={updateStartDate} isControl />
          </Control>
          <Control type="filter">
            <ScheduleListFilterContainer />
          </Control>
          <Control type="filter">
            <VenueSmartSpotStatus className="yield-management__smartspot-toggle" />
          </Control>
        </Controls>
        <ComponentErrorBoundary>
          <ScheduleList
            key={`${venueId}-${startDateFormatted}`}
            className="yield-management__schedule-list"
            venueId={venueId}
          />
        </ComponentErrorBoundary>
      </Column>
      <Column className="column-layout__column--lg-7/12 lg-pl-l" name="detail">
        <Controls />
        <ComponentErrorBoundary>
          {_isEmpty(selectedSchedule) ? <EmptyDetail /> : <ScheduleDetail key={selectedSchedule.scheduleId} />}
        </ComponentErrorBoundary>
      </Column>
    </ColumnLayout>
  );
};

YieldManagement.propTypes = {
  venueId: PropTypes.number,
  startDateFormatted: PropTypes.string,
  updateStartDate: PropTypes.func,
};

export default YieldManagement;
